<template>
  <div>
    <div class="Bleft">
      <Form ref="formDynamic" :model="formDynamic" :label-width="80">
        <List border size="small">
          <ListItem>
            <Col span="3">事由:</Col>
            <Col span="19">{{ shiyou }}</Col>
          </ListItem>
          <ListItem>
            <Col span="3">期望交付日期:</Col>
            <Col span="19">{{ jiaofuData }}</Col>
          </ListItem>
          <ListItem>
            <Col span="3">收货信息:</Col>
            <Col span="19">{{ shouhuoInfo }}</Col>
          </ListItem>
        </List>
        <!-- 表格 -->
        <h4 style="margin: 10px 0">明细:</h4>
        <Row :gutter="5">
          <Col span="24">
            <Table
              :columns="tableCols"
              :data="data2"
              :table="table"
              :border="table.border"
              :stripe="table.stripe"
              :header="table.header"
              :footer="table.footer"
              :columns-list="tableCols"
            >
            </Table
          ></Col>
        </Row>
        <h4 style="margin-top: 10px">备注:</h4>
        <Input
          style="margin: 10px 0"
          v-model="shippingOpinion"
          type="textarea"
          :autosize="{ minRows: 1, maxRows: 2 }"
        ></Input>
      </Form>
    </div>
    <Form ref="formDynamic" :model="formDynamic" :label-width="80">
      <FormItem label="物流单号:">
        <Row>
          <Col span="8">
            <Input v-model="oddnumbers" style="width: 250px" type="text"></Input>
          </Col>
          <Col span="8">
            <h3 class="zong">总价:{{ zongjia }}元</h3>
          </Col>
          <Col span="8">
            <h3 class="zong">优惠总价:{{ ratezongjia }}元</h3>
          </Col>
        </Row>
      </FormItem>
      <FormItem>
        <Button type="primary" @click="handleSubmit()">发货</Button>
      </FormItem>
    </Form>
  </div>
</template>
<script>
import { IMAGE_HOST } from "@/../config";
export default {
  props: {
    item: "",
  },
  data() {
    return {
      shippingOpinion: "",
      zongjia: 0,
      ratezongjia: 0,
      shiyou: "",
      jiaofuData: "",
      shouhuoInfo: "",
      num: "",
      table: {
        mname: "consumables",
        key: "id",
        url: {},
        output: false,
        border: true,
        rows: [],
        stripe: true,
        header: false,
        footer: false,
        order: "",
        router: {
          add: "",
          edit: "",
        },
      },
      formDynamic: {},
      index: 1,
      data2: [],
      tableCols: [
        {
          title: "序号",
          type: "index",
          width: 65,
          align: "center",
        },
        {
          title: "货物信息",
          width: 435,
          align: "center",
          render: (h, p) => {
            return h(
              "div",
              {
                style: {
                  width: "435px",
                  height: "80px",
                  display: "flex",
                  justifyContent: "flex-start",
                },
              },
              [
                h("img", {
                  style: {
                    width: "60px",
                    height: "60px",
                    margin: "10px",
                  },
                  attrs: { src: IMAGE_HOST + p.row.consumableImgUrl },
                }),
                h(
                  "div",
                  {
                    style: {
                      width: "300px",
                      marginTop: "10px",
                      textAlign: "left",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      whiteSpace: "nowrap",
                    },
                  },
                  [
                    h(
                      "p",
                      {
                        style: {},
                        domProps: {
                          title: p.row.brand + p.row.name,
                        },
                      },
                      p.row.brand + p.row.name
                    ),
                    h(
                      "p",
                      {
                        style: {
                          display: p.row.model == null ? "none" : "block",
                        },
                        domProps: {
                          title: "型号:" + p.row.model,
                        },
                      },
                      "型  号: " + p.row.model
                    ),
                    h(
                      "p",
                      {
                        style: {
                          width: "280px",
                          textAlign: "left",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          whiteSpace: "nowrap",
                          display: p.row.remark == null ? "none" : "block",
                        },
                        domProps: {
                          title: "适用于: " + p.row.remark,
                        },
                      },
                      "适用于: " + p.row.remark
                    ),
                  ]
                ),
              ]
            );
          },
        },
        {
          title: "公/本仓",
          key: "text",
          minWidth: 65,
          align: "center",
        },
        {
          title: "申请数",
          key: "alertNum",
          minWidth: 60,
          align: "center",
        },
        {
          title: "单位",
          key: "unit",
          minWidth: 65,
          align: "center",
          render: (h, params) => {
            const row = params.row;
            const text = row.unit;
            return <span style={{ "font-size": "14px" }}>{text}</span>;
          },
        },
        {
          title: "单价/元",
          key: "jdPrice",
          minWidth: 65,
          align: "center",
          render: (h, params) => {
            const row = params.row;
            const text = row.jdPrice ? row.jdPrice.toFixed(2) : 0;
            return <span style={{ "font-size": "14px" }}>{text}</span>;
          },
        },
        {
          title: "折扣率",
          key: "discountRate",
          minWidth: 65,
          align: "center",
          render: (h, params) => {
            const row = params.row;
            const text = row.discountRate;
            return <span style={{ "font-size": "14px" }}>{text}</span>;
          },
        },
        {
          title: "发货数量",
          key: "shipmentQuantity",
          minWidth: 120,
          align: "center",
          /* render: (h, params) => {
            return h(
              "InputNumber",
              {
                props: {
                  min: 0,
                  max: 100,
                  value: params.row.shipmentQuantity,
                },
                on: {
                  "on-change": (event) => {
                    this.obj.sysProcurementDetails[params.index].shipmentQuantity = event;
                    this.getzongjia(this.obj.sysProcurementDetails);
                    this.getRatezongjia(this.obj.sysProcurementDetails);
                  },
                },
                style: {
                  "font-size": "14px",
                  overflow: "hidden",
                  "text-overflow": "ellipsis",
                  "white-space": "nowrap",
                },
              },
              params.row.shipmentQuantity
            );
          }, */
        },
      ],
      obj: {},
      typearr: [],
      oddnumbers: "",
    };
  },
  async created() {
    await this.info();
  },
  methods: {
    async info() {
      let id = this.item;
      let res = await $utils.api.load(`/admin/system/procurementWork/${id}`);
      if (res.code == 200) {
        this.ratezongjia = res.data.endTotalPrice ? res.data.endTotalPrice.toFixed(2) : 0;
        this.shiyou = res.data.becauseWork;
        if (res.data.needTime) {
          var date = res.data.needTime;
          this.jiaofuData = date.split("T")[0];
        }
        this.shouhuoInfo = res.data.receivingInformation;
        let arr = res.data.sysProcurementDetails;
        this.obj = res.data;
        let num = arr.reduce((total, item) => {
          return total + item.jdPrice * item.shipmentQuantity;
        }, 0);
        this.zongjia = num.toFixed(2);
        for (let i = 0; i < arr.length; i++) {
          let obj = {};
          obj.consumableNum = arr[i].consumableNum;
          obj.consumableImgUrl = arr[i].consumableImgUrl;
          obj.brand = arr[i].brand;
          obj.name = arr[i].name;
          obj.model = arr[i].model;
          obj.remark = arr[i].remark;
          obj.num = arr[i].num;
          obj.id = arr[i].id;
          obj.unit = arr[i].unit;
          obj.alertNum = arr[i].alertNum;
          obj.unitPrice = arr[i].unitPrice;
          obj.jdPrice = arr[i].jdPrice;
          obj.consumableUuid = arr[i].consumableUuid;
          let ownNum = arr[i].ownNum == null ? 0 : arr[i].ownNum;
          let adminNum = arr[i].adminNum == null ? 0 : arr[i].adminNum;
          obj.discountRate = arr[i].discountRate == null ? 1 : arr[i].discountRate;
          obj.text = adminNum + "/" + ownNum;
          obj.shipmentQuantity =
            arr[i].shipmentQuantity == null ? 0 : arr[i].shipmentQuantity;
          obj.index = i;
          this.data2.push(obj);
        }
        // this.getzongjia(this.data2);
        // this.getRatezongjia(this.data2);
      }
    },
    getzongjia(list) {
      this.zongjia = 0;
      for (let i = 0; i < list.length; i++) {
        let num = list[i].shipmentQuantity;
        let Price = Number(list[i].jdPrice);
        this.zongjia += Price * num;
      }
      this.zongjia = this.zongjia.toFixed(2);
    },
    getRatezongjia(list) {
      this.ratezongjia = 0;
      for (let i = 0; i < list.length; i++) {
        let num = list[i].shipmentQuantity;
        let Price = Number(list[i].unitPrice);
        let rate = list[i].discountRate == null ? 1 : list[i].discountRate;
        console.log(rate);
        this.ratezongjia += Price * num * rate;
      }
      this.ratezongjia = this.ratezongjia.toFixed(2);
    },
    async handleSubmit() {
      if (this.oddnumbers == "") {
        await $utils.toast.error("请填写单号");
        return;
      }
      let q = this.obj;
      q.logisticsTrackingNum = this.oddnumbers;
      q.state = 4;
      q.shippingOpinion = this.shippingOpinion;
      q.sendTotalPrice = this.zongjia;
      let res = await $utils.api.load("/admin/system/procurementWork/edit", q, "post");
      if (res.code == 200) {
        await $utils.toast.success(res.message);
        this.$Modal.remove();
        setTimeout(function () {
          $utils.url.go(0);
        }, 1000);
      } else {
        $utils.toast.error(res.message);
      }
    },
  },
};
</script>
<style lang="less" scoped></style>
